// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Basic reset and animations that are easier to keep as CSS */

/* Parallax animations */
.hero-bar-graph,
.hero-pie,
.hero-line {
  transition: transform 0.7s cubic-bezier(0.4, 2, 0.6, 1), opacity 0.7s;
}

.hero-bar-graph.parallax {
  transform: translateY(calc(var(--parallax-bar, 0px) * 2)) scale(1.1) rotate(-2deg);
}

.hero-pie.parallax {
  transform: translateY(calc(var(--parallax-pie, 0px) * 2)) scale(1.2) rotate(8deg);
}

.hero-line.parallax {
  transform: translateY(calc(var(--parallax-line, 0px) * 2)) scale(1.1) rotate(-6deg);
}

/* Skill bar animations */
.bar-1::after,
.bar-2::after,
.bar-3::after,
.bar-4::after {
  content: "";
  display: block;
  height: 100%;
  background: #ffce3c;
  border-radius: 6px;
  transition: width 2.5s cubic-bezier(0.4, 1, 0.6, 1);
  width: 0;
  opacity: 1 !important;
  position: relative;
  z-index: 2;
}

.bar-animate.bar-1::after {
  width: 90%;
}

.bar-animate.bar-2::after {
  width: 75%;
}

.bar-animate.bar-3::after {
  width: 60%;
}

.bar-animate.bar-4::after {
  width: 50%;
}

/* Timeline fade in animation */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.timeline-card-animate {
  animation: fadeInUp 0.8s cubic-bezier(0.4, 2, 0.6, 1);
}

/* Modal animations */
.modal-enter {
  opacity: 0;
  transform: scale(0.7);
}

.modal-enter-active {
  opacity: 1;
  transform: scale(1);
  transition: opacity 0.38s cubic-bezier(0.4, 2, 0.6, 1),
              transform 0.38s cubic-bezier(0.4, 2, 0.6, 1);
}

.modal-exit {
  opacity: 1;
  transform: scale(1);
}

.modal-exit-active {
  opacity: 0;
  transform: scale(0.7);
  transition: opacity 0.3s ease-in-out,
              transform 0.3s ease-in-out;
}
`, "",{"version":3,"sources":["webpack://./src/styles/index.css"],"names":[],"mappings":"AAAA,8DAA8D;;AAE9D,wBAAwB;AACxB;;;EAGE,qEAAqE;AACvE;;AAEA;EACE,kFAAkF;AACpF;;AAEA;EACE,iFAAiF;AACnF;;AAEA;EACE,mFAAmF;AACrF;;AAEA,yBAAyB;AACzB;;;;EAIE,WAAW;EACX,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,mDAAmD;EACnD,QAAQ;EACR,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA,+BAA+B;AAC/B;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,qDAAqD;AACvD;;AAEA,qBAAqB;AACrB;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB;0DACwD;AAC1D;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB;wCACsC;AACxC","sourcesContent":["/* Basic reset and animations that are easier to keep as CSS */\n\n/* Parallax animations */\n.hero-bar-graph,\n.hero-pie,\n.hero-line {\n  transition: transform 0.7s cubic-bezier(0.4, 2, 0.6, 1), opacity 0.7s;\n}\n\n.hero-bar-graph.parallax {\n  transform: translateY(calc(var(--parallax-bar, 0px) * 2)) scale(1.1) rotate(-2deg);\n}\n\n.hero-pie.parallax {\n  transform: translateY(calc(var(--parallax-pie, 0px) * 2)) scale(1.2) rotate(8deg);\n}\n\n.hero-line.parallax {\n  transform: translateY(calc(var(--parallax-line, 0px) * 2)) scale(1.1) rotate(-6deg);\n}\n\n/* Skill bar animations */\n.bar-1::after,\n.bar-2::after,\n.bar-3::after,\n.bar-4::after {\n  content: \"\";\n  display: block;\n  height: 100%;\n  background: #ffce3c;\n  border-radius: 6px;\n  transition: width 2.5s cubic-bezier(0.4, 1, 0.6, 1);\n  width: 0;\n  opacity: 1 !important;\n  position: relative;\n  z-index: 2;\n}\n\n.bar-animate.bar-1::after {\n  width: 90%;\n}\n\n.bar-animate.bar-2::after {\n  width: 75%;\n}\n\n.bar-animate.bar-3::after {\n  width: 60%;\n}\n\n.bar-animate.bar-4::after {\n  width: 50%;\n}\n\n/* Timeline fade in animation */\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(40px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.timeline-card-animate {\n  animation: fadeInUp 0.8s cubic-bezier(0.4, 2, 0.6, 1);\n}\n\n/* Modal animations */\n.modal-enter {\n  opacity: 0;\n  transform: scale(0.7);\n}\n\n.modal-enter-active {\n  opacity: 1;\n  transform: scale(1);\n  transition: opacity 0.38s cubic-bezier(0.4, 2, 0.6, 1),\n              transform 0.38s cubic-bezier(0.4, 2, 0.6, 1);\n}\n\n.modal-exit {\n  opacity: 1;\n  transform: scale(1);\n}\n\n.modal-exit-active {\n  opacity: 0;\n  transform: scale(0.7);\n  transition: opacity 0.3s ease-in-out,\n              transform 0.3s ease-in-out;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
